<template>
  <v-menu
    offset-y
    :close-on-content-click="false"
    left
    nudge-bottom="8"
    max-width="360"
  >
    <template v-slot:activator="{ on, attrs }">
      <v-card outlined class="cs-card px-4 py-3" v-bind="attrs" v-on="on">
        <div class="d-flex align-center">
          <img :src="sparkleUrl" class="cs-sparkle mr-3" alt="credits" />
          <div>
            <div
              class="text-h6 font-weight-bold green--text text--darken-2 lh-1"
            >
              {{ formatNum(summary.available) }}
              {{ $t("reports.aiClient.credits") }}
            </div>
            <div class="grey--text text-caption">
              {{ $t("reports.aiClient.creditsAvailableLabel") }}
            </div>
          </div>
          <v-icon class="ml-2" color="grey">mdi-chevron-down</v-icon>
        </div>
      </v-card>
    </template>

    <v-card class="pa-3" width="340">
      <v-card outlined class="cs-card px-4 py-3 mb-3">
        <div class="d-flex align-center">
          <img :src="sparkleUrl" class="cs-sparkle-sm mr-3" alt="credits" />
          <div>
            <div
              class="text-h6 font-weight-bold green--text text--darken-2 lh-1"
            >
              {{ formatNum(summary.available) }}
              {{ $t("reports.aiClient.credits") }}
            </div>
            <div class="grey--text text-caption">
              {{ $t("reports.aiClient.creditsAvailableLabel") }}
            </div>
          </div>
        </div>
      </v-card>

      <div class="d-flex justify-space-between px-1 py-2 cs-row">
        <span class="grey--text text--darken-1">{{
          $t("reports.aiClient.totalCredits")
        }}</span>
        <span class="font-weight-bold black--text">{{
          formatNum(summary.total)
        }}</span>
      </div>
      <div class="d-flex justify-space-between px-1 py-2 cs-row">
        <span class="grey--text text--darken-1">{{
          $t("reports.aiClient.creditsUsedLabel")
        }}</span>
        <span class="font-weight-bold black--text">{{
          formatNum(summary.used)
        }}</span>
      </div>

      <div class="mt-3">
        <div class="d-flex" style="gap: 8px">
          <v-btn color="primary" depressed class="flex-grow-1" @click="onTopUp">
            {{ $t("reports.aiClient.topUp") }}
          </v-btn>
          <v-btn
            outlined
            color="primary"
            class="flex-grow-1"
            @click="$emit('history')"
          >
            {{ $t("reports.aiClient.creditsHistory") }}
          </v-btn>
        </div>
        <v-btn
          v-if="canManage"
          color="primary"
          depressed
          block
          class="mt-2"
          @click="$emit('manage')"
        >
          {{ $t("reports.aiClient.manageBtn") }}
        </v-btn>
      </div>
    </v-card>
  </v-menu>
</template>

<script>
/**
 * Header "Credits Available" card for the client AI Reports dashboard. Clicking
 * it opens a popover with the total/used breakdown and quick actions. Emits
 * `history` and `manage`; Top-up is informational (only Super Admin funds pools).
 */
import creditFormat from "@/mixins/creditFormat";

export default {
  name: "CreditsSummaryCard",
  mixins: [creditFormat],
  props: {
    summary: {
      type: Object,
      default: () => ({ available: 0, total: 0, used: 0 }),
    },
    // Only the parent cooperative admin manages credit config; sub-org admins
    // get a read-only dashboard (no Manage action).
    canManage: {
      type: Boolean,
      default: true,
    },
  },
  computed: {
    sparkleUrl() {
      return `${process.env.BASE_URL || "/"}icons/ai-reports/ai-fill.svg`;
    },
  },
  methods: {
    onTopUp() {
      this.$notify({
        title: this.$t("reports.aiClient.topUp"),
        text: this.$t("reports.aiClient.topUpInfo"),
        type: "info",
      });
    },
  },
};
</script>

<style scoped>
.cs-card {
  background: #f1faf4;
  border-color: #b7e3c9 !important;
  border-radius: 12px;
  cursor: pointer;
}
.lh-1 {
  line-height: 1.1;
}
.cs-row + .cs-row {
  border-top: 1px solid #eee;
}
.cs-sparkle {
  width: 38px;
  height: 38px;
}
.cs-sparkle-sm {
  width: 30px;
  height: 30px;
}
</style>
